export default __webpack_public_path__ + "static/media/altcoinbuzz_image.d0e911ca.png";